'use strict';

var processInclude = require('./util');

$(function () {
    processInclude(require('./components/postalCodeSearch'));
    processInclude(require('./components/zonePromotionNotice'));
});
